"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePopupResponseSchema = void 0;
var zod_1 = require("zod");
var itemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    image: zod_1.z.object({
        url: zod_1.z.string().url(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
    }),
    action: zod_1.z.object({
        app: zod_1.z.string().url(),
        web: zod_1.z.string().url(),
    }),
    logMeta: zod_1.z.object({
        title: zod_1.z.string(),
        popupId: zod_1.z.string(),
        popupSize: zod_1.z.string(),
    }),
});
exports.HomePopupResponseSchema = zod_1.z.object({ items: zod_1.z.array(itemSchema) });
